export default "__VITE_ASSET__jn3qP5R$__"